import React from "react";
import { FormInputField } from "@components-shared/mobile/inputs";

export default function RegistrationPOB(props: { labelClassName?: string }) {
	const { labelClassName } = props;

	return (
		<FormInputField
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml"
			name="birthPlace"
			minLength={3}
			maxLength={80}
			label="registration:BIRTH_PLACE_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:BIRTH_PLACE_PLACEHOLDER"
			pattern={{
				value: /^(?![-.])([\p{L}\p{Zs}\-.]*[\p{L}\p{Zs}])$/u,
				message: "registration:INVALID_BIRTH_PLACE",
			}}
			required
		/>
	);
}
